module.exports = __webpack_public_path__ + "media/game-video.e8ac7204.mp4";